import React, { useEffect } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { useAppDispatch } from "src/common/state/hooks";
import Chatbot from "src/features/chatbot/components/Chatbot";
import GptConversationLoader, {
  GPT_CONVERSATION_LOADER_COMPONENT_ID,
} from "src/features/chatbot/components/GptConversationLoader";
import RagAgentMultiSelect from "src/features/rag/components/RagAgentMultiSelect";
import {
  setActiveGptConversation,
  getGptConversationsSortedByRecency,
  getActiveGptConversation,
  fetchGptConversations,
  resetChat,
  getScenarioHelperRagAgentIds,
  setScenarioHelperRagAgentIds,
} from "src/features/chatbot/state/chatbotSlice";

const ScenarioHelperChat: React.FC = () => {
  const dispatch = useAppDispatch();
  const userPreviousGptConversations = useSelector(getGptConversationsSortedByRecency);
  const userActiveGptConversation = useSelector(getActiveGptConversation);
  const ragAgentIds = useSelector(getScenarioHelperRagAgentIds, shallowEqual);

  const handleConversationSelect = (conversationId: number) => {
    const selectedConversation = userPreviousGptConversations.find(
      (conv) => conv.id === conversationId,
    );
    if (selectedConversation) {
      dispatch(setActiveGptConversation(selectedConversation));
    }
  };

  const handleResetChat = () => {
    dispatch(resetChat({ cb: resetChatLocally })).then(() => {
      dispatch(
        fetchGptConversations({ componentId: GPT_CONVERSATION_LOADER_COMPONENT_ID, start: 0 }),
      );
    });
  };

  const resetChatLocally = () => {
    setActiveGptConversation(null);
  };

  useEffect(() => {
    dispatch(
      fetchGptConversations({ componentId: GPT_CONVERSATION_LOADER_COMPONENT_ID, start: 0 }),
    );
  }, [dispatch]);

  return (
    <div
      className="grid h-full w-full overflow-hidden"
      style={{ gridTemplateColumns: "240px 1fr 280px" }}
    >
      <div className="bg-gray-100 px-3 pt-1 border-r border-gray-200 overflow-y-auto overflow-x-hidden">
        <GptConversationLoader
          onConversationSelect={handleConversationSelect}
          onResetChat={handleResetChat}
        />
      </div>

      <div className="min-w-0 overflow-hidden">
        <Chatbot mode="scenarioHelper" activeConversation={userActiveGptConversation} />
      </div>

      <div className="bg-gray-50 border-l border-gray-200 p-4 overflow-y-auto overflow-x-hidden">
        <RagAgentMultiSelect
          value={ragAgentIds}
          onChange={(ids) => dispatch(setScenarioHelperRagAgentIds(ids))}
        />
      </div>
    </div>
  );
};

export default ScenarioHelperChat;
